'use client'
import { SelectOption } from '../../../../types/SelectInput'
import { CheckmarkSmallIcon } from '../../../icons'
import React, { ReactElement } from 'react'
import { components, OptionProps } from 'react-select'
import { Text } from '../../../atoms'

export const OptionReplacement = (props: OptionProps<SelectOption>): ReactElement => {
    const { value, label } = props.data

    return (
        //@ts-ignore
        <components.Option {...props}>
            <div
                className="flex items-center justify-between"
                data-cy={`input-select-option__value-${value}__label-${label}`}
                data-testid="select-input-option"
            >
                <Text className="text-wrap break-words w-full">{label}</Text>

                {props.isSelected && <CheckmarkSmallIcon className="ml-4 text-text-interactive" />}
            </div>
        </components.Option>
    )
}
